import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ConfirmEnrollmentApplicationResponse } from '@frontend/payments-care-credit';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import { CareCreditEnrollStepNavigationProps } from '../care-credit-enroll.types';

export const CareCreditEnrollGenericNavigation = ({ body: Body }: CareCreditEnrollStepNavigationProps) => {
  const {
    multiStep: { goPrevStep, onCancel, goNextStep },
    setCareCreditEnrollmentStatus,
    setCareCreditMessageType,
  } = useCollectPaymentMultiContext();

  const { t } = useTranslation('payments');

  const onGoBack = useCallback(() => {
    goPrevStep({
      orStep: PAYMENT_MULTI_STEPS.paymentMethods,
    });
  }, [goPrevStep]);

  const onEnrollmentAccepted = useCallback(
    (_result: ConfirmEnrollmentApplicationResponse) => {
      goNextStep({
        orStep: PAYMENT_MULTI_STEPS.careCreditCollect,
      });
    },
    [goNextStep]
  );

  const onEnrollmentDeclined = useCallback(
    ({ message }: ConfirmEnrollmentApplicationResponse) => {
      setCareCreditEnrollmentStatus({
        status: 'declined',
        message:
          message || t('Applicant was unable to prequalify for CareCredit. Please select another collection method.'),
      });
      goPrevStep({
        orStep: PAYMENT_MULTI_STEPS.paymentMethods,
      });
    },
    [goPrevStep, setCareCreditEnrollmentStatus]
  );

  const onGoToMessageStep = useCallback(() => {
    setCareCreditMessageType('enrollment-link');
    goNextStep({
      orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure,
    });
  }, [goNextStep]);

  return (
    <Body
      onGoBack={onGoBack}
      onCancel={onCancel}
      onEnrollmentAccepted={onEnrollmentAccepted}
      onEnrollmentDeclined={onEnrollmentDeclined}
      onGoToMessageStep={onGoToMessageStep}
    />
  );
};
